export default "__VITE_ASSET__BM8DnZgX__"